import { createFileRoute, redirect } from "@tanstack/react-router";
import { getDefaultLocale } from ":shared/lib/i18n";

export const Route = createFileRoute("/")({
	beforeLoad: () => {
		const locale = getDefaultLocale();
		throw redirect({
			to: "/$locale/dashboard",
			params: { locale },
			throw: true,
		});
	},
});
